module.exports = "/_next/static/images/operations1-d81aab95384a905273ddc6387450feec.svg";